module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-question"
  }, [_c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": require("../../static/images/indexNq-share.jpg")
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "question-pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.question.image
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "question-cont"
  }, [_c('h1', [_vm._v(_vm._s(_vm.question.question_title))]), _vm._v(" "), _vm._l((_vm.question.options), function(item, i) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.answerQuestion(item.option)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.optionIndex[i]) + ". " + _vm._s(item.title))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "question-nav"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.curQuestion > 1) & !_vm.submit),
      expression: "(curQuestion > 1) & !submit"
    }],
    staticClass: "prevQues",
    on: {
      "click": function($event) {
        _vm.toPrevQuestion()
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (((_vm.curQuestion) == _vm.questionListLength) & !_vm.submit),
      expression: "((curQuestion) == questionListLength) & !submit"
    }],
    staticClass: "submitQues",
    on: {
      "click": function($event) {
        _vm.submitAnswers()
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (((_vm.curQuestion) == _vm.questionListLength) & _vm.submit),
      expression: "((curQuestion) == questionListLength) & submit"
    }],
    staticClass: "submitWait"
  }, [_vm._v("提交中")])]), _vm._v(" "), _c('div', {
    staticClass: "question-progress"
  }, [_c('div', {
    staticClass: "progress-bg"
  }, [_c('i', {
    style: ({
      width: (_vm.curQuestion / _vm.questionListLength) * 100 + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "progress-text"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.curQuestion) + "/" + _vm._s(_vm.questionListLength) + "\n\t\t\t")])]), _vm._v(" "), _c('yxl-logo'), _vm._v(" "), (_vm.finishTest) ? _c('div', {
    staticClass: "hasDone"
  }, [_c('div', {
    staticClass: "mask"
  }, [_vm._v("!")]), _vm._v(" "), _c('div', {
    staticClass: "dialog"
  }, [_c('h1', [_vm._v("WARNNING")]), _vm._v(" "), _c('p', [_vm._v("您已完成本次测试，请勿重复提交。")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.toFunreport()
      }
    }
  }, [_vm._v("朕知道了")])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-4f32a26f!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/question.vue
// module id = 133
// module chunks = 2